import { linkButtonStyled } from '@web/atomic/atm.button/button.component.style';
import { Link } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';

export const LinkButtonStyled = styled(Link as any)`
  ${linkButtonStyled}
`;
